import Cookies from 'js-cookie'

export const USER_SESSION_KEY = 'invoicing_user'

export const getStoredUser = () => {
    try {
        const raw = sessionStorage.getItem(USER_SESSION_KEY)
        return raw ? JSON.parse(raw) : null
    } catch {
        return null
    }
}

export const storeUser = (user) => {
    if (user) {
        sessionStorage.setItem(USER_SESSION_KEY, JSON.stringify(user))
    }
}

export const clearStoredUser = () => {
    sessionStorage.removeItem(USER_SESSION_KEY)
}

export const clearAuthToken = () => {
    Cookies.remove('token')
    Cookies.remove('refresh')
}

export const persistAuth = (data) => {
    const token = data?.token || data?.access || data?.tokens?.access
    const refresh = data?.refresh || data?.tokens?.refresh

    if (token) {
        Cookies.set('token', token, { expires: 7 })
    }
    if (refresh) {
        Cookies.set('refresh', refresh, { expires: 7 })
    }
    if (data?.user) {
        storeUser(data.user)
    }
}

export const signOut = () => {
    clearAuthToken()
}

export const getUserDisplayName = (user) => {
    if (!user) return 'User'
    const name = [user.first_name, user.last_name].filter(Boolean).join(' ').trim()
    return name || user.email || 'User'
}
